const specialRegions = [
    /*MoscowRegion*///1001, 45, 46,
    /*LeningradRegion*///1002, 62, 40,
    /*Krim region*///1003, 37, 68
];
const groupSpecialRegions = [
    /*Moscow*///1001,
    /*Linin*///1002,
    /*Krim*///1003,
];

const specialKcpGroups = [
    136, 142, 181, 186
];

export default {specialRegions, groupSpecialRegions, specialKcpGroups}